import Alert from 'client/components/ui/Alert/Alert';
import Button from 'client/components/aria/Button/Button';
import WarningText from 'client/components/aria/WarningText/WarningText';
import Modal from 'client/components/ui/Modal/Modal';
import { useIntl } from 'react-intl';
import styles from './EnquiryAlertModal.module.scss';

const EnquiryAlertModal = ({
    showWarningDialog,
    setShowWarningDialog,
    onConfirm,
    enquiryTitle,
    variant = 'info'
}) => {
    const closeModal = () => {
        setShowWarningDialog(false);
    };

    const intl = useIntl();
    const isDelete = Boolean(onConfirm);

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        } else {
            closeModal();
        }
    };

    return (
        <Modal
            data-testid="enquiryAlert.modal"
            open={showWarningDialog}
        >
            <Alert className={styles.alertModal} data-testid="save.bookmark.dialog.alert" variant={variant}>
                {isDelete
                    ? (
                        <>
                            <h2 className="govuk-heading-m">
                                {intl.formatMessage({ id: 'enquiryAlerts.modal.delete.title' })}
                            </h2>
                            <p className="govuk-body">
                                {intl.formatMessage({ id: 'enquiryAlerts.modal.delete.body' }, { title: enquiryTitle })}
                            </p>
                            <div className="govuk-button-group">
                                <Button
                                    data-testid="enquiryAlerts.modal.confirm"
                                    variant="error"
                                    className={styles.alertButton}
                                    onPress={handleConfirm}
                                >
                                    {intl.formatMessage({ id: 'enquiryAlerts.modal.button.delete.text' })}
                                </Button>
                                <Button
                                    data-testid="enquiryAlerts.modal.cancel"
                                    variant="default"
                                    className={styles.alertButton}
                                    onPress={closeModal}
                                >
                                    {intl.formatMessage({ id: 'enquiryAlerts.modal.button.cancel.text' })}
                                </Button>
                            </div>
                        </>
                    )
                    : (
                        <>
                            <WarningText message={intl.formatMessage({ id: 'EnquiryPageTitle.warningBody' })} />
                            <Button
                                data-testid="enquiryAlerts.Modal.Ok"
                                variant="success"
                                className={styles.alertButton}
                                onPress={closeModal}
                            >
                                {intl.formatMessage({ id: 'enquiryAlerts.modal.button.save.text' })}
                            </Button>
                        </>
                    )}
            </Alert>
        </Modal>
    );
};

export default EnquiryAlertModal;
